// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"ed8428ee","193":"939fb31f","213":"60f34e62","238":"98dd39f7","239":"90eb8bfe","450":"32e4c9a8","553":"a2d9deb2","557":"b55628f7","790":"335a7e8f"}[chunkId] + ".chunk.js";
};